import React from 'react'
import { currencyFormatWithDisplay } from '../../../../../main/configs/currency'

import Icon from '../../../../components/icon'
import { useOrder } from '../../../../contexts/order'
import { dateDiff, extractHourToMinutes, formatDate } from '../../../../helpers/helper-date'
import { formatCurrency } from '../../../../helpers/helper-price'
import {
  Container,
  OrderStatusCard,
  OrderId,
  CreatedAt,
  CardsWrapper,
  Card,
  CostumerInfo,
  PriceInfo,
  DollarSignWrapper,
  PriceFooter,
} from './styles'

const CustomerDetails = () => {
  const { orderPad } = useOrder()
  if (!orderPad) return null
  const createdAt = new Date(orderPad.createdAt).getTime() + (3600000 * 3)
  const minutesDiff = dateDiff(
    new Date(createdAt),
    new Date(),
  )
  const { hour, minute } = extractHourToMinutes(minutesDiff)
  const customerPermanence = `${hour && `${hour}h`}${minute && `${minute}min`}`
  const total = orderPad.orders.reduce((acc: number, order: any) => (
    acc + order.product.price * order.amount
  ), 0)

  return (
    <Container>
      <OrderStatusCard>
        <div>
          <OrderId>
            Mesa:
            {` ${orderPad.stablishmentTable.name}`}
            <div />
            Iniciou em
            {formatDate(orderPad.createdAt, ' DD/MM ')}
            às
            {formatDate(orderPad.createdAt, ' HH:mm')}
          </OrderId>

          <CreatedAt>
            <Icon name="clock" />
            <p>
              Permanência
              <em>{customerPermanence}</em>
            </p>
          </CreatedAt>
        </div>
      </OrderStatusCard>

      <CardsWrapper>
        <Card>
          <CostumerInfo>
            <li>
              <h4>Nome</h4>
              <p>{orderPad.client.name || '--'}</p>
            </li>
            <li>
              <h4>E-mail</h4>
              <p>{orderPad.client.email || '--'}</p>
            </li>
            <li>
              <h4>Contato</h4>
              <p>{orderPad.client.phoneNumber || '--'}</p>
            </li>
          </CostumerInfo>
        </Card>

        <Card>
          <PriceInfo>
            <DollarSignWrapper>
              <Icon name="dollar-sign" />
            </DollarSignWrapper>

            <PriceFooter>
              <h3>Total gasto</h3>
              <p>{formatCurrency(total, currencyFormatWithDisplay, 'pt-BR')}</p>
            </PriceFooter>
          </PriceInfo>
        </Card>
      </CardsWrapper>

    </Container>
  )
}

CustomerDetails.defaultProps = {
  orderPad: null,
}

export default CustomerDetails
